import { Plus, Trash2, X, CheckCircle2, XCircle } from "lucide-react";
import AdminPageShell from "@/admin/AdminPageShell";
import { useAdminTestimonialItems } from "@/admin/useAdminTestimonialItems";

const AdminTestimonials = () => {
  const { items, editing, loading, openNew, close, save, toggleApproved, remove, updateEditingField } = useAdminTestimonialItems();

  return (
    <AdminPageShell
      title="Testimonials"
      description="Moderate and publish client testimonials."
      actions={<button onClick={openNew} className="btn-solid-pearl btn-pill-sm" data-testid="admin-testimonials-new-btn"><Plus size={14} /> New Testimonial</button>}
      testId="admin-testimonials-page"
    >
      {editing && (
        <form onSubmit={save} className="neu-panel p-6 mb-8 space-y-4" data-testid="admin-testimonial-form">
          <div className="flex items-center justify-between">
            <span className="eyebrow">New Testimonial</span>
            <button type="button" onClick={close}><X size={18} /></button>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <input required placeholder="Name" value={editing.name} onChange={(e) => updateEditingField("name", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-testimonial-name-input" />
            <input placeholder="Role / Company" value={editing.role_or_company} onChange={(e) => updateEditingField("role_or_company", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-testimonial-role-input" />
          </div>
          <textarea required placeholder="Quote" value={editing.quote} onChange={(e) => updateEditingField("quote", e.target.value)} className="neu-inset w-full p-3" rows={3} data-testid="admin-testimonial-quote-input" />
          <input placeholder="Brand (optional)" value={editing.brand} onChange={(e) => updateEditingField("brand", e.target.value)} className="neu-inset w-full h-11 px-3" data-testid="admin-testimonial-brand-input" />
          <button type="submit" className="btn-solid-pearl" data-testid="admin-testimonial-save-btn">Save</button>
        </form>
      )}

      {loading ? <p className="text-small">Loading…</p> : (
        <div className="space-y-3">
          {items.map((t) => (
            <div key={t.id} className="neu-surface p-5 flex items-center justify-between gap-4 flex-wrap" data-testid={`admin-testimonial-row-${t.id}`}>
              <div className="flex-1">
                <p className="text-body" style={{ color: "var(--gg-ivory)" }}>&ldquo;{t.quote}&rdquo;</p>
                <p className="text-small mt-1">{t.name}{t.role_or_company ? ` · ${t.role_or_company}` : ""}</p>
              </div>
              <div className="flex items-center gap-3">
                <button onClick={() => toggleApproved(t)} data-testid={`admin-testimonial-toggle-${t.id}`} title={t.approved ? "Approved" : "Hidden"}>
                  {t.approved ? <CheckCircle2 size={18} style={{ color: "var(--gg-logo-gold)" }} /> : <XCircle size={18} style={{ color: "var(--gg-muted-text)" }} />}
                </button>
                <button onClick={() => remove(t.id)} data-testid={`admin-testimonial-delete-${t.id}`}><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
          {items.length === 0 && <p className="text-small">No testimonials yet.</p>}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminTestimonials;
